import { ICON_USER } from '@global/constants';
import { RoutePaths } from '@global/routePaths';

export const situationSteps = [
  {
    id: 'situation',
    title: 'STEPS.SITUATION.TITLE',
    iconClass: ICON_USER,
    steps: [
      // Verti client
      {
        title: 'STEPS.SITUATION.TITLE',
      },
      // Family situation
      {
        title: 'STEPS.SITUATION.TITLE',
      },
      // Policy starting date
      {
        title: 'STEPS.SITUATION.TITLE',
      },
    ],
    route: RoutePaths.NEW_QUOTATION.SITUATION.VERTI_CLIENT.route,
  },
];
